<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';
import EhTalkChat from './components/EhTalkChat.vue';
import ModalQueroSerCliente from './components/ModalQueroSerCliente.vue';
import { iniciarExitIntent } from './services/exitIntent';
import { analytics } from './services/analyticsService';

const exitIntentAberto = ref(false);
let pararExitIntent = () => {};

onMounted(() => {
  pararExitIntent = iniciarExitIntent(() => {
    exitIntentAberto.value = true;
    analytics.leadFormStart('exit_intent');
  });
});

onBeforeUnmount(() => {
  pararExitIntent();
});
</script>

<template>
  <router-view></router-view>
  <EhTalkChat />
  <ModalQueroSerCliente
    :aberto="exitIntentAberto"
    @fechar="exitIntentAberto = false"
  />
</template>
